
import Vue from "vue";
import flvjs from "flv.js";
import Hls from "hls.js";

export default {
  props: ["src"],
  data() {
    return {
      flvPlayer: null as flvjs.Player | null,
      hlsPlayer: null as Hls | null,
    };
  },
  watch: {
    src(newVal: string) {
      this.initPlay(newVal);
    },
  },
  mounted() {
    this.initPlay(this.src);
  },
  beforeDestroy() {
    this.destroyPlayer();
  },
  methods: {
    // 销毁播放器实例，释放资源
    destroyPlayer() {
      if (this.flvPlayer) {
        this.flvPlayer.destroy();
        this.flvPlayer = null;
      }
      if (this.hlsPlayer) {
        this.hlsPlayer.destroy();
        this.hlsPlayer = null;
      }
    },

    initPlay(url: string) {
      const video = this.$refs.videoRef as HTMLVideoElement;
      if (!video || !url) return;

      // 切换地址先销毁旧实例
      this.destroyPlayer();

      // HLS m3u8 流
      if (url.endsWith(".m3u8")) {
        if (Hls.isSupported()) {
          this.hlsPlayer = new Hls({
            maxBufferLength: 10,
            maxMaxBufferLength: 20,
          });
          this.hlsPlayer.loadSource(url);
          this.hlsPlayer.attachMedia(video);
          this.hlsPlayer.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play().catch((err) => {
              console.warn("hls play error:", err);
            });
          });
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          // Safari 原生支持 m3u8
          video.src = url;
          video.play().catch((err) => console.warn("safari hls play error", err));
        }
      }
      // FLV 直播流
      else if (url.endsWith(".flv") || url.includes(".flv")) {
        if (flvjs.isSupported()) {
          this.flvPlayer = flvjs.createPlayer(
            {
              type: "flv",
              url: url,
              isLive: true, // 直播true；回放录像改为false
            },
            {
              enableWorker: true,
              enableStashBuffer: false,
              stashInitialSize: 128,
            }
          );
          this.flvPlayer.attachMediaElement(video);
          this.flvPlayer.load();
          this.flvPlayer.play().catch((err) => {
            console.warn("flv play error", err);
          });
        }
      }
      // 普通mp4等原生视频
      else {
        video.src = url;
        video.play().catch((err) => console.warn("normal play error", err));
      }
    },
  },
};
